import { Globe, ChevronDown } from 'lucide-react';
import { useI18nContext, SupportedLanguage } from '../../lib/i18n';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

const languageLabels: Record<SupportedLanguage, { code: string; name: string }> = {
  en: { code: 'EN', name: 'English' },
  fi: { code: 'FI', name: 'Suomi' },
  sv: { code: 'SV', name: 'Svenska' },
};

interface LanguageDropdownProps {
  languages: SupportedLanguage[];
  className?: string;
}

const LanguageDropdown = ({ languages, className = '' }: LanguageDropdownProps) => {
  const { language, setLanguage } = useI18nContext();
  const currentLabel = languageLabels[language] ?? languageLabels.fi;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`h-7 px-2 rounded hover:bg-sidebar-foreground/30 transition-colors flex items-center gap-1 outline-none ${className}`}
          aria-label="Change language"
        >
          <Globe size={16} />
          <span className="text-sm">{currentLabel.code}</span>
          <ChevronDown
            size={14}
            className="transition-transform duration-200 [[data-state=open]>&]:rotate-180"
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-28 bg-sidebar border-sidebar-border z-100001"
      >
        <DropdownMenuRadioGroup
          value={language}
          onValueChange={(value) => setLanguage(value as SupportedLanguage)}
        >
          {languages.map((lang) => {
            const label = languageLabels[lang];
            if (!label) return null;
            return (
              <DropdownMenuRadioItem
                key={lang}
                value={lang}
                className="focus:bg-sidebar-foreground/30"
              >
                {label.name}
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageDropdown;
